/* eslint-disable @nx/enforce-module-boundaries */
import { ChevronDownIcon } from '@chakra-ui/icons';
import { ArrowDown, CloseBlueIcon } from '@mybridge/icons';
import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormLabel,
  HStack,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
  Stack,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDisclosure } from '@mybridge/ui';
import { FilterPopoverPopper } from 'v4/components/filter-keyword-popover';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { SearchContext } from 'v4/snippets/search/context';
export const SearchFilterKeywords = forwardRef(
  ({ title = 'Keyword', titleKey = 'searchPage.keyword', onChange, value, defaultValue, ...props }, ref) => {
    const { handleSubmit, register, reset } = useForm();
    const { t } = useTranslator();
    const { onOpen, onClose, isOpen } = useDisclosure();
    const {refetchPeopleSearch} = useContext(SearchContext);

    const onSubmit = (form) => {
      onChange?.(form);
      refetchPeopleSearch({
        query: '', // or pass keyword if you have a "query" field separately
        peopleFilters: form,
      });
    };

    // useEffect(() => {
    //   if (!defaultValue) {
    //     reset();
    //   }
    // }, [defaultValue]);

    return (
      <>
        {/* <form style={{width:"175px"}}> */}
        <form style={{width:"100%"}}>
          <FilterPopoverPopper
            placement="auto"
            trigger={
              <Button
                variant="transparent"
                fontSize="14px"
                color="brandGray.750"
                justifyContent="space-between"
                w="100%"
                px={1}
                type="button"
              >
                <HStack w="100%" justifyContent="space-between" spacing={1} overflow="hidden">
                  <Text noOfLines={1} textAlign="left" flex={1} title={t(titleKey) || title}>
                    {t(titleKey) || title}
                  </Text>
                  <Box flexShrink={0}>
                    <ArrowDown />
                  </Box>
                </HStack>
              </Button>
            }
            withForm
            submitHandler={handleSubmit(onSubmit)}
            onPopClose={(e) => console.log()}
          >
            <Stack p={"20px"}>
              {/* <Stack style={{display: 'flex', flexDirection: 'row',  justifyContent: 'space-between', alignItems: 'center'}}>
                <Heading size="md" fontWeight={400} color="#3D5A80">{(t(titleKey) || title)}</Heading>
              </Stack> */}
              <Stack direction={['column', 'row']}>
                <FormControl>
                  <FormLabel fontWeight={400}>{t('searchPage.firstName') || "First Name"}</FormLabel>
                  <Input style={{border: "1px solid #DDDDDD"}} textTransform="capitalize" placeholder={t('searchPage.firstName') || "First Name"} {...register('first_name')} />
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight={400}>{t('searchPage.lastName') || "Last Name"}</FormLabel>
                  <Input style={{border: "1px solid #DDDDDD"}} textTransform="capitalize" placeholder={t('searchPage.lastName') || "Last Name"} {...register('last_name')} />
                </FormControl>
              </Stack>
              <Stack direction={['column', 'row']}>
                <FormControl>
                  <FormLabel fontWeight={400}>{t('searchPage.title') || "Title"}</FormLabel>
                  <Input style={{border: "1px solid #DDDDDD"}} textTransform="capitalize" placeholder={t('searchPage.title') || "Title"} {...register('company_title')} />
                </FormControl>
              </Stack>
              <Stack direction={['column', 'row']}>
                <FormControl>
                  <FormLabel fontWeight={400}>{t('searchPage.currentCompany') || "Current Company"}</FormLabel>
                  <Input
                    placeholder={t('searchPage.currentCompany') || "Current Company"}
                    textTransform="capitalize"
                    style={{border: "1px solid #DDDDDD"}}
                    {...register('current_company')}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight={400}>{t('searchPage.pastCompany') || "Past Company"}</FormLabel>
                  <Input
                    placeholder={t('searchPage.pastCompany') || "Past Company"}
                    textTransform="capitalize"
                    style={{border: "1px solid #DDDDDD"}}
                    {...register('past_company')}
                  />
                </FormControl>
              </Stack>
              <Stack direction={['column', 'row']}>
                <FormControl>
                  <FormLabel fontWeight={400}>{t('education.school') || "School"}</FormLabel>
                  <Input placeholder={t('education.school') || "School"} textTransform="capitalize" style={{border: "1px solid #DDDDDD"}} {...register('school')} />
                </FormControl>
              </Stack>
            </Stack>
          </FilterPopoverPopper>
        </form>
      </>
    );
  }
);
